import React from 'react';
import {
  List,
  Datagrid,
  Responsive,
  SimpleList,
  TopToolbar,
  SelectField
} from 'react-admin';

import { makeStyles } from '@material-ui/core';
import ListTitleBar from '../../core/components/ListTitleBar';
import SplitDocumentIcon from '@material-ui/icons/CallSplit';
import { typeChoices, matchingFields } from './SplitMethodTypeLookups';
import BulkActionDeleteButton from '../../core/components/BulkActionDeleteButton';
import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';

const useStyles = makeStyles({
  dataGridHead: {
    '& tr': {
      '& th:nth-of-type(1)': {
        width: '24px'
      }
    }
  },
  root: {
    marginRight: 'auto'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();

  return (
    <TopToolbar classes={{ root: classes.root }}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const SplitMethodTitle = props => {
  return (
    <ListTitleBar
      type="Split Methods"
      title="Create New Split Method"
      createUrl="#/splitmethods/create"
      icon={<SplitDocumentIcon />}
      hasCreatePermission={props.hasCreatePermission}
      buttonId="Create New Split Method"
    />
  );
};

const SplitMethodList = props => {
  const classes = useStyles();
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    userProfile,
    ...rest
  } = props;

  return (
    <List
      {...rest}
      exporter={false}
      actions={<Actions />}
      title={<SplitMethodTitle hasCreatePermission={hasCreatePermission} />}
      sort={{ field: 'name', order: 'ASC' }}
      bulkActionButtons={
        hasDeletePermission && (
          <BulkActionDeleteButton resource="splitmethods" />
        )
      }
      pagination={null}
      empty={<Empty />}
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.id}
            secondaryText={record => record.name}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid
            classes={{ thead: hasDeletePermission && classes.dataGridHead }}
          >
            <LinkField label="Name" source="name" sortable={false} />
            <SelectField
              source="externalId"
              choices={matchingFields}
              label="Matching Field"
              sortable={false}
              id="Matching Field"
            />
            <SelectField
              source="type"
              choices={typeChoices}
              optionValue="code"
              sortable={false}
              id="type"
            />
          </Datagrid>
        }
      />
    </List>
  );
};

export default SplitMethodList;
